import { render } from "./ModuleManagement.vue?vue&type=template&id=227f59b7&ts=true"
import script from "./ModuleManagement.vue?vue&type=script&lang=ts"
export * from "./ModuleManagement.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__